import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-very-brifly-datewise',
  templateUrl: './very-brifly-datewise.component.html',
  styleUrls: ['./very-brifly-datewise.component.scss']
})
export class VeryBriflyDatewiseComponent implements OnInit {
  rep_name: any;
  off_rep_name: any;
  issue_date: any;
  start_date: any;
  end_date: any;
  type: any;
  issue_cat: any;
  today1:any;

  inDetailsRegReport: any;
  inDetailsRegReportdatewise: any;
  inDetailsRegReportrep: any;

  newissuedatepp: any;

  indetail = false;
  datewise = false;
  officerep = false;
  showindetail = false;
  show = false;
  isLoading = false; // ✅ Add this to fix template error

  advtamt = 0;
  netadvtamt = 0;
  totaladvtamt = 0;
  totalgst = 0;
  totalpendingadvtamt = 0;
  totaldisc_total = 0;
  remaingtotal = 0;
  totalbeforegst_amt = 0;
  total_pending = 0;
  jamatotal = 0;

  filteredinDetailsRegReport: any;
  categoryNameForHTML: any;
  issueNameForHTML: any;
  issuecopies: number;

  constructor(
    private dialogref: MatDialogRef<VeryBriflyDatewiseComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
      this.type = this.data['type'];
      this.start_date = this.data['start_date'];
      this.end_date = this.data['end_date'];
      this.rep_name = this.data['rep_name'];
      this.off_rep_name = this.data['off_rep_name'];
      this.newissuedatepp = this.data['newissuedatepp'];
    
      this.issue_cat = this.data['issue_cat'] === undefined ? "ALL" : this.data['issue_cat'];
    
      // Extract only the date part (before first comma)
      const issueDateRaw = this.data['issueDates'];
      if (Array.isArray(issueDateRaw) && issueDateRaw.length > 0) {
        this.issue_date = issueDateRaw[0].split(',')[0];
      } else {
        this.issue_date = "ALL";
      }
    
      console.log("Final Payload Data:", {
        representativeId: this.rep_name,
        startDate: this.start_date,
        endDate: this.end_date,
        officeRepresentativeId: this.off_rep_name,
        issueNameId: this.issue_cat,
        issueSellerDate: this.issue_date
      });
    this.getRegReportData();
  }

getRegReportData() {
  this.isLoading = true;
  const req1 = {
    rep_name: this.rep_name,
    start_date: this.start_date,
    end_date: this.end_date,
    off_rep_name: this.off_rep_name,
    issuename: this.issue_cat,
    issue_date: this.issue_date
  };

  this.service.getissueRegReportInDetailsdatewise(req1).subscribe((data) => {
    this.inDetailsRegReport = data;
    this.inDetailsRegReportdatewise = data;
    this.inDetailsRegReportrep = data;

    // ✅ Reset totals before summing
    this.issuecopies = 0;
    this.netadvtamt = 0;
    this.totaladvtamt = 0;
    this.totalgst = 0;
    this.jamatotal = 0;
    this.totalbeforegst_amt = 0;
    this.total_pending = 0;

    if (this.inDetailsRegReportrep) {
      for (let data2 of this.inDetailsRegReportrep) {
        for (let data1 of data2.issue_data) {
          this.issuecopies += parseFloat(data1.issue_copies) || 0;
          this.totaladvtamt += parseFloat(data1.issue_amt) || 0;
          this.netadvtamt += parseFloat(data1.net_amount) || 0;
          this.totalbeforegst_amt += parseFloat(data1.beforegst_amt) || 0;

          const gstVal =
            (parseFloat(data1.sgst) || 0) +
            (parseFloat(data1.cgst) || 0) +
            (parseFloat(data1.igst) || 0);
          this.totalgst += gstVal;

          this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
          this.total_pending += parseFloat(data1.remaining_amt) || 0;
        }
      }
    }

    this.addFilters();
    this.getReportDatewise();
    this.isLoading = false;
  }, error => {
    this.isLoading = false;
    console.error("Error fetching data:", error);
  });
}


  addFilters() {
    this.filteredinDetailsRegReport = this.inDetailsRegReportdatewise;
  }

  getReportDatewise() {
    // Your datewise logic
  }

  print() {
    // ✅ Fix for missing print method
    this.printPage3();
  }

  exportExcel(sheetName: string) {
    // ✅ Fix for missing exportExcel method
    const dataToExport = this.inDetailsRegReportdatewise || [];
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Sheet1');
    XLSX.writeFile(wb, `${sheetName}.xlsx`);
  }

  printPage3() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) return;

    const printContent = printSection.innerHTML;
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1500;
    const leftPosition = screenWidth - windowWidth - 50;

    const printWindow = window.open('', '', `width=${windowWidth},height=1000,top=50,left=${leftPosition},scrollbars=yes`);
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report</title>
            <style>
              @media print {
                @page { size: A3 landscape; margin: 3mm; }
                body { font-family: Arial; font-size: 10px; color: #000; -webkit-print-color-adjust: exact; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #000; padding: 3px 5px; }
                th { background-color: #f2f2f2; font-weight: bold; }
                .noPrint { display: none; }
              }
            </style>
          </head>
          <body onload="window.print();window.close()">
            <div class="print-section">${printContent}</div>
          </body>
        </html>
      `);
      printWindow.document.close();
    }
  }
}
